import { ref } from 'vue'

export interface MallTrackingTarget {
  idx: number
  courier?: string
  invoice?: string
  name?: string
  orderCode?: string
}

export function useMallTracking() {
  const trackTarget = ref<MallTrackingTarget | null>(null)

  function openTracking(item: MallTrackingTarget) {
    if (!item?.idx) return
    trackTarget.value = item
  }

  function closeTracking() {
    trackTarget.value = null
  }

  return { trackTarget, openTracking, closeTracking }
}
